import { ApolloClient } from '@apollo/client';
import { NormalizedCacheObject } from '@apollo/client/cache';
import { ImagesPreloadQuery } from '@catalogo/core-types';
import query from './images-preload.graphql';

interface Component {
  large: string;
  medium: string;
  small: string;
  children: Component[];
}

export const getPreloadedImages = (client: ApolloClient<NormalizedCacheObject>) => {
  const data = client.readQuery<ImagesPreloadQuery>({
    query,
    variables: {
      path: '/',
    },
  });
  let images: string[] = [];

  const components = data?.page?.components;

  images = images.concat(getImages(components?.maintop1));
  images = images.concat(getImages(components?.maintop2));

  return images.slice(0, 6);
};

const getImages = (position: Component): string[] => {
  try {
    return position.children
      .map((data: Component) => {
        const image = data.small || data.large || data.medium;
        if (!image && position.children.length > 0) {
          return getImages(data);
        }

        return image;
      })
      .flat()
      .filter(Boolean);
  } catch (e) {
    return [];
  }
};
